import { render, staticRenderFns } from "./EmpresasTable.vue?vue&type=template&id=a3643084&scoped=true"
import script from "./EmpresasTable.vue?vue&type=script&lang=js"
export * from "./EmpresasTable.vue?vue&type=script&lang=js"
import style0 from "./EmpresasTable.vue?vue&type=style&index=0&id=a3643084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3643084",
  null
  
)

export default component.exports